import { render, staticRenderFns } from "./PRJ911M03.vue?vue&type=template&id=23ad71a7&"
import script from "./PRJ911M03.vue?vue&type=script&lang=js&"
export * from "./PRJ911M03.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports